import { FINALIZATION_STATUSES } from './constants';

export const getFinalizationStatus = invoice => {
  if (!invoice.finalizationStatus) return FINALIZATION_STATUSES.READY_TO_INITIATE;
  if (invoice.finalizationStatus === 'DONE') return FINALIZATION_STATUSES.DONE;
  const errorStep = getErrorStep(invoice);
  if (errorStep) return FINALIZATION_STATUSES.ERROR;
  return FINALIZATION_STATUSES.IN_PROGRESS;
};

export const getErrorStep = invoice => {
  if (!invoice.finalizationLog) return null;
  const steps = Object.values(invoice.finalizationLog ?? {});
  return steps.find(s => s.error && !s.done);
};

export const mapInvoiceToCopy = (invoice, vehicle, buyingCompany = {}) => {
  let vehiclePriceField = '';
  let isInclBtwBpm = invoice?.btwOrMarge == 'BTW';
  let vehicleSubject = invoice?.invoiceSubjects?.find(s => s?.type === 'vehicle');

  if (vehicleSubject?.btwOrMarge == 'BTW' && !isInclBtwBpm) {
    vehiclePriceField = 'financial_price_excl_vat_excl_bpm';
  }
  if (vehicleSubject?.btwOrMarge == 'BTW' && isInclBtwBpm) {
    vehiclePriceField = 'financial_price_incl_vat_bpm';
  }
  if (vehicleSubject?.btwOrMarge == 'marge' && !isInclBtwBpm) {
    vehiclePriceField = 'financial_price_marge_excl_bpm';
  }
  if (vehicleSubject?.btwOrMarge == 'marge' && isInclBtwBpm) {
    vehiclePriceField = 'financial_price_marge_incl_bpm';
  }
  const parsedInvoiceValues = {
    outgoingCompanyId: invoice?.outgoingCompanyId,
    client: invoice?.outgoingUserId,
    main_cost: vehicleSubject?.[vehiclePriceField],
    tax_type: isInclBtwBpm ? 'incl.BTW/BPM' : 'excl.BTW/BPM',
    secondaryProducts: invoice?.invoiceSubjects
      ?.filter(subject => {
        return subject?.product?.id;
      })
      ?.map(productSubject => {
        const product = {
          productId: productSubject?.product.id,
          cost: productSubject?.price,
          incl: true,
          costType: productSubject?.product?.name,
          isTransport: productSubject?.product.isTransport,
          description: productSubject?.product.description,
        };
        return product;
      }),
    delivery_location: invoice?.outgoingCompany,
    main_location: buyingCompany,
    financial_contact: invoice?.financialContactId,
    email_contact: invoice?.emailContactId,
    send_to_email: invoice?.emailTo,
    seller: invoice?.userSellerId,
    sell_with_license_plate: vehicle?.sell_with_license_plate,
    fix_damages: vehicle?.fix_damages,
    fixed_damages_details: vehicle?.fix_damages_details,
    bpm_guarantee_sum: vehicle?.bpm_guarantee_sum,
    BPM_refund_via_indewal: vehicle?.BPM_refund_via_indewal,
    zulassung_aanvragen: vehicle?.zulassung_aanvragen,
    BPM_refund: vehicle?.BPM_refund,
    outgoing_bpm_refund_deposit: vehicle?.outgoing_bpm_refund_deposit,
    comment: invoice?.invoiceAdditionalLines?.[0]?.value,
    pickedUp: vehicle?.pickedUp,
  };

  return parsedInvoiceValues;
};

export const mapIncomingInvoiceToCopy = invoice => {
  const parsedInvoiceValues = {
    creditor_company: invoice?.incomingCompanyId,
    creditor: invoice?.incomingUserId,
  };

  return parsedInvoiceValues;
};
